import { Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import React, { Fragment, useMemo, useState } from "react";
import { DateFormatTo_YYYY_MM_DD, CSTDateFormatterWithTime_12_hr } from "../../utils/DateFormatter";
import WithConditional from "../hoc/WithConditional";
import Loader from "../UI/Loader";
import { useErrorLogData } from "../../hooks/useErrorLogData";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import classes from "../Workbench/Workbench.module.css"
import CustomizedSnackbars from "../UI/SnackBar";
import { getToken, tokenConfig } from "../../authfile";

const FilesTracker = () => {
  const tokenConfig = {
    headers: {
        "Authorization": `Bearer ${getToken()}`,
    },
  };
  const [fileErrorsDate, setFileErrorsDate] = useState(dayjs(new Date()));
  const formattedFileDate = fileErrorsDate ? DateFormatTo_YYYY_MM_DD(fileErrorsDate) : '';
  const { file_errors, report_errors, isFetching, isError: isErrorLogData, error: errorLogDataError } = useErrorLogData({body: {
    fileDate: formattedFileDate,
    fromDate: "",
    toDate: "",
    key: 1
  },config: tokenConfig});

  const ColumnsOfFileStats = useMemo(
    () => [
      {
        accessorKey: 'Date', //access nested data with dot notation
        header: 'DATE',
        size: 150,
        filterVariant: 'date',
        sortingFn: (rowA, rowB, columnId) => {
          if (rowA.original.Date == null || rowA.original.Date == undefined) {
            return -1;
          }
          if (rowB.original.Date == null || rowB.original.Date == undefined) {
            return 1;
          }
          const firstDate = new Date(rowA.original.Date);
          const secondDate = new Date(rowB.original.Date);
          return firstDate > secondDate ? 1 : -1;
        },
        filterFn: (row, columnId, filterValue) => {
          if (row.original.Date === null || row.original.Date === undefined) {
            return false;
          }
          const rowValue = new Date(new Date(row.original.Date));
          rowValue.setHours(0, 0, 0, 0);
          const start = filterValue;
          const startDate = start ? new Date(start) : null;


          if (!start)
            return true;


          if (startDate)
            startDate.setHours(0, 0, 0, 0);

          if (startDate)
            return rowValue.toDateString() === startDate.toDateString();

        },

        enableColumnFilter: true,
      },
      {
        accessorKey: 'FileNameCount', //access nested data with dot notation
        header: 'TOTAL FILES',
        size: 150,
      },
      {
        accessorKey: 'SuccessCount', //access nested data with dot notation
        header: 'SUCCESSCOUNT',
        size: 150,
      },
      {
        accessorKey: 'ErrorCount', //access nested data with dot notation
        header: 'ERRORCOUNT',
        size: 150,
      },

    ],
    [],
  );

  const ColumnsOfEachReport = useMemo(
    () => [
      {
        accessorKey: 'Report Name', //access nested data with dot notation
        header: 'REPORT NAME',
        size: 150,
      },
      {
        accessorKey: 'Status', //access nested data with dot notation
        header: 'STATUS',
        size: 150,
      },
      {
        accessorKey: 'New Cases Loaded', //access nested data with dot notation
        header: 'NEW CASES',
        size: 150,
      },
      {
        accessorKey: 'Timestamp', //access nested data with dot notation
        header: 'TIMESTAMP',
        size: 150,
        filterVariant: 'date',
        sortingFn: (rowA, rowB, columnId) => {
          if (rowA.original.Timestamp == null || rowA.original.Timestamp == undefined) {
            return -1;
          }
          if (rowB.original.Timestamp == null || rowB.original.Timestamp == undefined) {
            return 1;
          }
          const firstDate = new Date(rowA.original.Timestamp);
          const secondDate = new Date(rowB.original.Timestamp);
          return firstDate > secondDate ? 1 : -1;
        },
        filterFn: (row, columnId, filterValue) => {
          const rowValue = new Date(new Date(row.original.Timestamp));
          rowValue.setHours(0, 0, 0, 0);
          const start = filterValue;
          const startDate = start ? new Date(start) : null;


          if (!start)
            return true;


          if (startDate)
            startDate.setHours(0, 0, 0, 0);


          if (startDate)
            return rowValue.toDateString() === startDate.toDateString();

        },

        enableColumnFilter: true,
      },

    ],
    [],
  );

  const tableOfFileStats = useMaterialReactTable({
    columns: ColumnsOfFileStats,
    data: file_errors, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    renderTopToolbarCustomActions: () => <Fragment>
      <Typography variant="h7" color="primary" sx={{ fontWeight: 'bold', borderBottom: '1px solid #002277' }}>FILE WISE STATS</Typography>
    </Fragment>
  });

  const tableOfReportStats = useMaterialReactTable({
    columns: ColumnsOfEachReport,
    data: report_errors, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    renderTopToolbarCustomActions: () => <Fragment>
      <Typography variant="h7" color="primary" sx={{ fontWeight: 'bold', borderBottom: '1px solid #002277' }}>REPORT WISE STATS</Typography>
    </Fragment>
  });

  return (
    <Fragment>
      <WithConditional when={isFetching}>
        <Loader />
      </WithConditional>
      <WithConditional when={isErrorLogData}>
        <CustomizedSnackbars type="error" API="Files Tracker Logs API" message={errorLogDataError?.message} />
      </WithConditional>
      <div className={classes.dayFilterRight}>
        <div className={classes.startDate}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker label="Select Date"
              value={fileErrorsDate}
              sx={{
                display: 'inline-block',
                '& input': {
                  padding: '8px 14px !important',

                },

                '& .MuiInputLabel-root': {
                  marginTop: '-3% !important',
                  fontWeight: 'bold'
                }

              }}
              onChange={(newValue) => setFileErrorsDate(newValue)}
              format="MM-DD-YYYY"
            />
          </LocalizationProvider>
        </div>
      </div>
      <div style={{ marginBottom: '2rem', marginTop: '2rem' }}>
        <MaterialReactTable table={tableOfFileStats} />
      </div>
      <div>
        <MaterialReactTable table={tableOfReportStats} />
      </div>
    </Fragment>
  )
}

export default FilesTracker;